import CryptoJS from 'crypto-js';

export const encryptData = (data) => {
  const secretKey = process.env.REACT_APP_DATA_ENC_SECRET_KEY;
  if (!secretKey) {
    return '';
  }
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

/** Returns parsed data, or null if missing key, corrupt payload, or wrong secret. Never throws. */
export const decryptData = (encryptedData) => {
  const secretKey = process.env.REACT_APP_DATA_ENC_SECRET_KEY;
  if (!encryptedData || !secretKey) {
    return null;
  }
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const plain = decryptedBytes.toString(CryptoJS.enc.Utf8);
    if (!plain) {
      return null;
    }
    return JSON.parse(plain);
  } catch {
    return null;
  }
};